<template>
<v-container class="mb-0 px-2">
    <h2 class="texts">{{title}}</h2>
    <v-data-table
        dense
        hide-default-footer
        :headers="headers"
        :items="list"
        class="lotesListTable"
        :page.sync="pagination.offset"
        :items-per-page="pagination.limit"
        @page-count="pagination.total_pages = parseInt($event, pagination.limit)"
      >
      <template v-slot:item.data_execucao="{ item }">
          <b>{{ item.data_execucao | formatDate}}</b>
      </template>
      <template v-slot:item.codigoTabela="{ item }">
        <div class="tabela-info ma-0" style="max-width: 150px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">
          <b v-if="getDescricaoDominio('dm_tabela', item.codigoTabela).length<24">{{getDescricaoDominio('dm_tabela', item.codigoTabela)}}</b>
          <v-tooltip bottom v-else>
            <template v-slot:activator="{ on, attrs }" >
              <span v-bind="attrs" v-on="on" class="pa-0">
               <b>{{getDescricaoDominio('dm_tabela', item.codigoTabela)}}</b>
              </span>
            </template>
            <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF">{{getDescricaoDominio('dm_tabela', item.codigoTabela)}}</span>
          </v-tooltip>
        </div>
      </template>
      <template v-slot:item.tabela="{ item }">
        <div class="tabela-info ma-0" style="max-width: 150px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">
          <v-tooltip bottom v-if="!!item.tabela && item.tabela != null">
            <template v-slot:activator="{ on, attrs }" >
              <span v-bind="attrs" v-on="on" class="pa-0">
               <b>item.tabela</b>
              </span>
            </template>
            <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF">item.tabela_descricao</span>
          </v-tooltip>
        </div>
      </template>
      <template v-slot:item.codigoProcedimento="{ item }">
        <b>{{item.codigoProcedimento}}</b>
      </template>
      <template v-slot:item.sequencialItem="{ item }">
        <b>{{item.sequencialItem}}</b>
      </template>
      <template v-slot:item.descricaoProcedimento="{ item }">
        <b>{{ item.descricaoProcedimento }}</b>
      </template>
      <template v-slot:item.quantidadeExecutada="{ item }">
        <b>{{ item.quantidadeExecutada }}</b>
      </template>
      <template v-slot:item.valorUnitario="{ item }">
        <b>{{ item.valorUnitario | formatPrice }}</b>
      </template>
      <template v-slot:item.valorTotal="{ item }">
            {{ Number(item.valorTotal) | formatPrice }}
      </template>
    </v-data-table>
    <div class="text-center mt-2 col-md-12">
        <v-pagination class="no-box-shadow" v-model="pagination.offset" :length="pagination.total_pages"></v-pagination>
    </div>
</v-container>
</template>

<script>
export default {
  data() {
    return {
      qtde: 1, 
      porcent: 0,
      countList: 0,
      pagination: {
        offset: 1,
        limit: 20,
        total_pages: 1
      }
    }
  },
    props:{
      headers: Array,
      list: Array,
      title: String,
      dominioTiss: Object      
    },
    methods: {
       getDescricaoDominio(tabela, valor){
        if(tabela == "dm_tabela" && valor =="0"){
           valor = "00";
        }
        let dominioItem = this.dominioTiss[tabela].find(el=> el.valor==valor)
        return dominioItem? dominioItem.descricao : 'Tabela de código '+ valor
      }
    }
}
</script>

<style>
tr:first-child.destaque {
  border-bottom: solid 2px #d1dcea;
  background-color: #d1dcea;
}
</style>